(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["verani-inventory"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('verani-inventory')) {
    customElements.define('verani-inventory', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          this.readyHandler = () => this.initialize();
          document.addEventListener('DOMContentLoaded', this.readyHandler, { once: true });
        } else this.initialize();
      }
      initialize() {
        if (this.dataset.mode !== 'automatic' || this.controller) return;
        let data;
        try { data = JSON.parse(this.querySelector('[data-vi-variants]').textContent); } catch { return; }
        this.variants = data.variants || [];
        this.initialId = data.selected;
        this.controller = new AbortController();
        this.scope = this.closest('.rd-product') || this.closest('.shopify-section') || this.parentElement;
        const schedule = () => {
          if (this.pending) return;
          this.pending = true;
          queueMicrotask(() => {
            this.pending = false;
            if (this.isConnected) this.update();
          });
        };
        if (this.dataset.followProduct === 'true') {
          for (const eventName of ['click', 'change', 'input', 'variant:change', 'variant:changed', 'product:variant-change']) {
            this.scope.addEventListener(eventName, schedule, { signal: this.controller.signal });
          }
          window.addEventListener('popstate', schedule, { signal: this.controller.signal });
        }
        this.update();
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.readyHandler);
        this.controller?.abort();
        this.controller = null;
      }
      update() {
        let id = this.initialId;
        if (this.dataset.followProduct === 'true') {
          const input = this.scope.querySelector('[data-rd-variant-input], form[action*="/cart/add"] [name="id"]');
          id = input?.value || new URL(window.location.href).searchParams.get('variant') || id;
        }
        const variant = this.variants.find(item => String(item.id) === String(id));
        if (!variant) return;
        let state = 'in_stock';
        if (!variant.available) state = 'sold_out';
        else if (variant.tracked && variant.quantity <= 0 && variant.policy === 'continue') state = 'preorder';
        else if (variant.tracked && variant.quantity > 0 && variant.quantity <= Number(this.dataset.threshold)) state = 'limited';
        const key = state + ':' + variant.quantity;
        if (this.lastMessage === key) return;
        this.lastMessage = key;
        this.dataset.state = state;
        const template = this.querySelector('[data-vi-message="' + state + '"]');
        const copy = this.querySelector('[data-vi-copy]');
        if (!template || !copy) return;
        const content = template.content.cloneNode(true);
        const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) node.textContent = node.textContent.replaceAll('{quantity}', String(variant.quantity));
        copy.replaceChildren(content);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
